// extracted by mini-css-extract-plugin
module.exports = {"root":"_12ySPe16bqwU","type_review":"_3jkRuVjA_ybG","orderCode":"X0EYRa9ZYcTD"};